import React from 'react';
import { makeStyles } from '@mui/styles';
import { Container, Typography, Link } from '@mui/material';
import Grid from '@mui/material/Grid';
import { isAuthorized } from '../../services/auth';
import { Link as LinkTo } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  main: {
    marginTop: theme.spacing(8),
    marginBottom: theme.spacing(2),
  },
}));

function Error404() {
  const classes = useStyles();
  return (
    <Container className={classes.main}>
      <Grid container alignItems="center" justifyContent="center">
        <Grid item xs={6}>
          <Typography variant="h2">Página não encontrada!</Typography>
          <br />
          <Typography variant="h5">
            Se você acredita que isto é um erro,
            {' '}
            <Link to="/suporte" component={LinkTo}>
              contate o suporte
            </Link>
            {' ou volte para a '}
            {isAuthorized() ? (
              <Link to="/property" component={LinkTo}>
                página inicial.
              </Link>
            ) : (
              <Link to="https://crevettic.com/">página inicial.</Link>
            )}
          </Typography>
        </Grid>
      </Grid>
    </Container>
  );
}

export default Error404;
